import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

// Genera ids usados en el template (labels for="...")
function makeIds() {
    const cats = [
        "permanentes", "eventuales", "altas", "asig", "letras", "conclusiones",
        "bajas", "ascensos", "varios", "destinos", "cuadro", "modal"
    ];
    const ids = { fd: {}, fh: {} };
    cats.forEach(c => { ids.fd[c] = `fd-${c}`; ids.fh[c] = `fh-${c}`; });
    return ids;
}

export default {
    name: "ReporteSPPage",
    components: { dataTable, Loader },

    data() {
        const ss = new MainService();
        return {
            msg: "ReporteSPPage",
            ss,
            auth: {},
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},

            // variables para todos los reportes
            variables: { FechaDesde: null, FechaHasta: null },

            conceptosp: {},
            rutaApp: process.env.VUE_APP_MAIN_SERVICE,
            situacionconcepto: {},

            // modal genérico
            showModal: false,
            currentKey: null,

            // ids para el template
            ids: makeIds(),

            // fechas del cuadro de alteraciones
            cuadrosba: { FechaDesde: null, FechaHasta: null },

            // switches (checkboxes)
            cuadros: {
                Daen: false, Dem: false, Depss: false, Dim: false, Magister: false,
                Frontera: false, Profesional: false, ProLibro: false, EspecialidadProf: false,
                incorpInstituosMil: false, incorpPersCivil: false, reincorpPersCivil: false, reincorpPersMil: false,
                incorpArt114: false, incorpArt118: false,
                Lactancia: false, Natalidad: false, Mortalidad: false, Prenatal: false,
                LactanciaConPaquete: false, PrenatalConPaquete: false,
                LetraA: false, LetraB: false, LetraC: false, LetraD: false,
                LetraEjustMil: false, LetraEjustOrd: false, AplicArt87: false, AplicArt114: false,
                cLetraB: false, cLetraC: false, cLetraD: false, cLetraEjustMil: false, cLetraEjustOrd: false,
                cBonoProLibro: false, cCursoMil: false, cDestinoMil: false, csefectobdisponible: false,
                ExoneracionCargo: false, Fallecimiento: false, Jubilacion: false,
                RetiroObligatorio: false, RetiroVoluntario: false,
                BajaTemporalLicenciaMaxima: false, BajaLicenciaTemporal: false,
                oga: false, PostOga: false, Postumo: false,
                CambioEscalafon: false, ModificacionDatos: false,
                ogd: false, PostOgd: false, Radicatoria: false, CursoMil: false, DestTemp: false, ReservaAct: false,
                PostOgdAlfabetico: false, PostOgdFechas: false,
                BajaResTSJM: false,
                BajaResPTJM: false,
                BajaJubilacionCivil: false,
                BajaArt94y127: false,
                BajaDefArt94: false,
                BajaDefArt127: false,
                BajaJubilacionObservada: false,
            },

            // grupos para el cuadro de alteraciones
            groups: [
                {
                    key: "permanentes",
                    title: "B. PERMANENTES",
                    options: [
                        { key: "Daen", label: "DAEN" },
                        { key: "Dem", label: "DEM" },
                        { key: "Depss", label: "DEPSS" },
                        { key: "Dim", label: "DIM" },
                        { key: "Magister", label: "MAGISTER" },
                    ],
                },
                {
                    key: "eventuales",
                    title: "B. EVENTUALES",
                    options: [
                        { key: "Frontera", label: "FRONTERA" },
                        { key: "Profesional", label: "PROFESIONAL" },
                        { key: "ProLibro", label: "PROLIBRO" },
                        { key: "EspecialidadProf", label: "ESPECIALIDAD PROFESIONAL" },
                    ],
                },
                {
                    key: "altas",
                    title: "ALTAS",
                    options: [
                        { key: "incorpInstituosMil", label: "INCORP. EGR. II.MM." },
                        { key: "incorpPersCivil", label: "INCORP. PERS. CIVIL" },
                        { key: "reincorpPersCivil", label: "REINCORP. PERS. CIVIL" },
                        { key: "reincorpPersMil", label: "REINCORP. PERS. MILITAR" },
                        { key: "incorpArt114", label: "INCORP. ART. 114" },
                        { key: "incorpArt118", label: "INCORP. ART. 118" },
                    ],
                },
                {
                    key: "asigfam",
                    title: "ASIG. FAMILIARES",
                    options: [
                        { key: "Lactancia", label: "LACTANCIA" },
                        { key: "Natalidad", label: "NATALIDAD" },
                        { key: "Mortalidad", label: "MORTALIDAD" },
                        { key: "Prenatal", label: "PRENATAL" },
                        { key: "LactanciaConPaquete", label: "LACTANCIA CON PAQUETE" },
                        { key: "PrenatalConPaquete", label: "PRENATAL CON PAQUETE" },
                    ],
                },
                {
                    key: "letras",
                    title: "LETRAS",
                    options: [
                        { key: "LetraA", label: "LETRA A" },
                        { key: "LetraB", label: "LETRA B" },
                        { key: "LetraC", label: "LETRA C" },
                        { key: "LetraD", label: "LETRA D" },
                        { key: "LetraEjustMil", label: "LETRA E JUSTICIA MILITAR" },
                        { key: "LetraEjustOrd", label: "LETRA E JUSTICIA ORDINARIA" },
                        { key: "AplicArt87", label: "APLICACIÓN DEL ART. 87" },
                        { key: "AplicArt114", label: "APLICACIÓN DEL ART. 114" },
                    ],
                },
                {
                    key: "conclusiones",
                    title: "CONCLUSIONES",
                    options: [
                        { key: "cLetraB", label: "CONCL. LETRA B" },
                        { key: "cLetraC", label: "CONCL. LETRA C" },
                        { key: "cLetraD", label: "CONCL. LETRA D" },
                        { key: "cLetraEjustMil", label: "CONCL. LETRA E JUST. MILITAR" },
                        { key: "cLetraEjustOrd", label: "CONCL. LETRA E JUST. ORDINARIA" },
                        { key: "cBonoProLibro", label: "CONCL. BONO PRO LIBRO" },
                        { key: "cCursoMil", label: "CONCL. CURSO MILITAR" },
                        { key: "cDestinoMil", label: "CONCL. DESTINO TEMPORAL" },
                        { key: "csefectobdisponible", label: "SIN EFECTO LETRA B DE DISPONIBILIDAD" },
                    ],
                },
                {
                    key: "bajas",
                    title: "BAJAS",
                    options: [
                        { key: "ExoneracionCargo", label: "POR EXONERACIÓN DEL CARGO" },
                        { key: "Fallecimiento", label: "POR FALLECIMIENTO" },
                        { key: "Jubilacion", label: "POR JUBILACIÓN" },
                        { key: "RetiroObligatorio", label: "POR RETIRO OBLIGATORIO" },
                        { key: "RetiroVoluntario", label: "POR RETIRO VOLUNTARIO" },
                        { key: "BajaTemporalLicenciaMaxima", label: "BAJA TEMP. LICENCIA MÁXIMA" },
                        { key: "BajaLicenciaTemporal", label: "BAJA LICENCIA TEMPORAL" },
                        // === NUEVOS ===
                        { key: "BajaResTSJM", label: "BAJA POR RESOLUCIÓN TSJM" },
                        { key: "BajaResPTJM", label: "BAJA POR RESOLUCIÓN PTJM" },
                        { key: "BajaJubilacionCivil", label: "PASE A LA JUBILACIÓN (CIVIL)" },
                        { key: "BajaArt94y127", label: "BAJA ART. 94° Y 127°" },
                        { key: "BajaDefArt94", label: "BAJA DEFINITIVA ART. 94° LOFA" },
                        { key: "BajaDefArt127", label: "BAJA DEFINITIVA ART. 127° CPM" },
                        { key: "BajaJubilacionObservada", label: "JUBILACIÓN CON OBSERVACIÓN" },
                    ],
                },
                {
                    key: "ascensos",
                    title: "ASCENSOS",
                    options: [
                        { key: "oga", label: "POR O.G.A." },
                        { key: "PostOga", label: "POSTERIOR A LA O.G.A." },
                        { key: "Postumo", label: "ASCENSO PÓSTUMO" },
                    ],
                },
                {
                    key: "varios",
                    title: "VARIOS",
                    options: [
                        { key: "CambioEscalafon", label: "CAMBIO DE ESCALAFÓN" },
                        { key: "ModificacionDatos", label: "MODIFICACIÓN DE DATOS" },
                    ],
                },
                {
                    key: "destinos",
                    title: "DESTINOS",
                    options: [
                        { key: "ogd", label: "CAMBIO DE DESTINO POR O.G.D." },
                        { key: "PostOgd", label: "POSTERIOR O.G.D." },
                        { key: "Radicatoria", label: "RADICATORIA" },
                        { key: "CursoMil", label: "CURSO MILITAR" },
                        { key: "DestTemp", label: "DESTINO TEMPORAL" },
                        { key: "ReservaAct", label: "RESERVA ACTIVA" },
                        { key: "PostOgdAlfabetico", label: "POST. O.G.D. (ORDEN ALFABÉTICO)" },
                        { key: "PostOgdFechas", label: "POST. O.G.D. POR FECHAS" },
                    ],
                },
            ],

            // listas de botones para el modal (coinciden con openModal(btn.key) del template)
            permanentesBtns: [
                { key: "Daen", label: "DAEN" },
                { key: "Dem", label: "DEM" },
                { key: "Depss", label: "DEPSS" },
                { key: "Dim", label: "DIM" },
                { key: "Magister", label: "MAGISTER" },
            ],
            eventualesBtns: [
                { key: "Frontera", label: "FRONTERA" },
                { key: "Profesional", label: "PROFESIONAL" },
                { key: "ProLibro", label: "PROLIBRO" },
                { key: "EspecialidadProf", label: "ESPECIALIDAD PROFESIONAL" },
            ],
            altasBtns: [
                { key: "incorpInstituosMil", label: "INCORP. EGR. II.MM." },
                { key: "incorpPersCivil", label: "INCORP. PERS. CIVIL" },
                { key: "reincorpPersCivil", label: "REINCORP. PERS. CIVIL" },
                { key: "reincorpPersMil", label: "REINCORP. PERS. MILITAR" },
                { key: "incorpArt114", label: "INCORP. ART. 114" },
                { key: "incorpArt118", label: "INCORP. ART. 118" },
            ],
            asigBtns: [
                { key: "Lactancia", label: "LACTANCIA" },
                { key: "Natalidad", label: "NATALIDAD" },
                { key: "Mortalidad", label: "MORTALIDAD" },
                { key: "Prenatal", label: "PRENATAL" },
                { key: "LactanciaConPaquete", label: "LACTANCIA CON PAQUETE", warn: true },
                { key: "PrenatalConPaquete", label: "PRENATAL CON PAQUETE", warn: true },
            ],
            letrasBtns: [
                { key: "LetraA", label: "LETRA A" },
                { key: "LetraB", label: "LETRA B" },
                { key: "LetraC", label: "LETRA C" },
                { key: "LetraD", label: "LETRA D" },
                { key: "LetraEjustMil", label: "LETRA E JUSTICIA MILITAR" },
                { key: "LetraEjustOrd", label: "LETRA E JUSTICIA ORDINARIA" },
                { key: "AplicArt87", label: "APLICACIÓN DEL ART. 87" },
                { key: "AplicArt114", label: "APLICACIÓN DEL ART. 114" },
            ],
            conclusionesBtns: [
                { key: "cLetraB", label: "CONCL. LETRA B" },
                { key: "cLetraC", label: "CONCL. LETRA C" },
                { key: "cLetraD", label: "CONCL. LETRA D" },
                { key: "cLetraEjustMil", label: "CONCL. LETRA E JUST. MILITAR" },
                { key: "cLetraEjustOrd", label: "CONCL. LETRA E JUST. ORDINARIA" },
                { key: "cBonoProLibro", label: "CONCL. BONO PRO LIBRO" },
                { key: "cCursoMil", label: "CONCL. CURSO MILITAR" },
                { key: "cDestinoMil", label: "CONCL. DESTINO TEMPORAL" },
                { key: "csefectobdisponible", label: "SIN EFECTO LETRA B DE DISPONIBILIDAD" },
            ],
            bajasBtns: [
                { key: "ExoneracionCargo", label: "POR EXONERACIÓN DEL CARGO" },
                { key: "Fallecimiento", label: "POR FALLECIMIENTO" },
                { key: "Jubilacion", label: "POR JUBILACIÓN" },
                { key: "RetiroObligatorio", label: "POR RETIRO OBLIGATORIO" },
                { key: "RetiroVoluntario", label: "POR RETIRO VOLUNTARIO" },
                { key: "BajaTemporalLicenciaMaxima", label: "BAJA TEMP. LICENCIA MÁXIMA" },
                { key: "BajaLicenciaTemporal", label: "BAJA LICENCIA TEMPORAL" },
                { key: "BPasepasivo", label: "PASE AL SERVICIO PASIVO" },
                { key: "BajaDefArt94", label: "BAJA DEF. DEL EJTO. SEGÚN ART. 94° LOFA" },
                { key: "BajaDefArt127", label: "BAJA DEF. SEGÚN ART. 127° CÓDIGO PENAL MILITAR" },
                { key: "BajaArt94y127", label: "BAJA SEGÚN ART. 94° Y ART. 127° CÓDIGO PENAL MILITAR" },
                { key: "BajaResPTJM", label: "POR RES. PTJM." },
                { key: "BajaResTSJM", label: "POR RES. TSJM" },
            ],
            ascensosBtns: [
                { key: "oga", label: "POR O.G.A." },
                { key: "PostOga", label: "POSTERIOR A LA O.G.A." },
                { key: "Postumo", label: "ASCENSO PÓSTUMO" },
            ],
            variosBtns: [
                { key: "CambioEscalafon", label: "CAMBIO DE ESCALAFÓN" },
                { key: "ModificacionDatos", label: "MODIFICACIÓN DE DATOS" },
            ],
            destinosBtns: [
                { key: "ogd", label: "CAMBIO DE DESTINO POR O.G.D." },
                { key: "PostOgd", label: "POSTERIOR O.G.D." },
                { key: "PostOgdAlfabetico", label: "POST. O.G.D. (ORDEN ALFABÉTICO)", warn: true },
                { key: "PostOgdFechas", label: "POST. O.G.D. POR FECHAS", warn: true },
                { key: "Radicatoria", label: "RADICATORIA" },
                { key: "CursoMil", label: "CURSO MILITAR" },
                { key: "DestTemp", label: "DESTINO TEMPORAL" },
                { key: "ReservaAct", label: "RESERVA ACTIVA" },
            ],

            // key del botón -> método de servicio
            actionMap: {
                // Permanentes
                Daen: "printPDaen", Dem: "printPDem", Depss: "printPDepss", Dim: "printPDim", Magister: "printPMagister",
                // Eventuales
                Frontera: "printEFrontera", Profesional: "printEProfesional", ProLibro: "printEProlibro", EspecialidadProf: "printEEspecialidadprof",
                // Altas
                incorpInstituosMil: "printAIniimm", incorpPersCivil: "printAInpc", reincorpPersCivil: "printAReipc",
                reincorpPersMil: "printAReipm", incorpArt114: "printAIncorporacion114", incorpArt118: "printAIncorporacion118",
                // Asignaciones familiares
                Lactancia: "printAFLactancia", Natalidad: "printAFNatalidad", Mortalidad: "printAFMortalidad",
                Prenatal: "printAFPrenatal", LactanciaConPaquete: "printAFLactanciaConPaquete", PrenatalConPaquete: "printAFPrenatalConPaquete",
                // Letras
                LetraA: "printLLetraA", LetraB: "printLLetraB", LetraC: "printLLetraC", LetraD: "printLLetraD",
                LetraEjustMil: "printLLetraEJM", LetraEjustOrd: "printLLetraEJO", AplicArt87: "printLArt87", AplicArt114: "printLArt114",
                // Conclusiones
                cLetraB: "printCConclusionLetraB", cLetraC: "printCConclusionLetraC", cLetraD: "printCConclusionLetraD",
                cLetraEjustMil: "printCConclusionLetraEJM", cLetraEjustOrd: "printCConclusionLetraEJO",
                cBonoProLibro: "printCConclusionProLibro", cCursoMil: "printCConclusionCursoMil", cDestinoMil: "printCConclusionDestinoTemp",
                csefectobdisponible: "printCConclusionSEfectobdisponible",
                // Bajas (mapeo a tus métodos reales 89/90)
                ExoneracionCargo: "printBExoneracion", Fallecimiento: "printBFallecido", Jubilacion: "printBPasepasivo",
                RetiroObligatorio: "printBRetiro89", RetiroVoluntario: "printBRetiro90",
                BajaTemporalLicenciaMaxima: "printBBajaTLM", BajaLicenciaTemporal: "printBBajaLT",
                BajaJubilacion: "printBJubilacion", BPasepasivo: "printBJubilacion",

                // Estos 5 asumen que crearás los endpoints; si usas otros nombres, cámbialos aquí:
                BajaDefArt94: "printBBajaDefArt94",
                BajaDefArt127: "printBBajaDefArt127",
                BajaArt94y127: "printBBajaArt94y127",
                BajaResPTJM: "printBBajaResPTJM",
                BajaResTSJM: "printBBajaResTSJM",
                BajaJubilacionCivil: "printBJubilacionCivil",
                BajaJubilacionObservada: "printBJubilacionObservada",
                // Ascensos
                oga: "printASOGA", PostOga: "printASPosteriorOGA", Postumo: "printASPostumo",
                // Varios
                CambioEscalafon: "printVEscalafon", ModificacionDatos: "printVModificacion",
                // Destinos
                ogd: "printDOGD", PostOgd: "printDPosterior", Radicatoria: "printDRadicatoria",
                CursoMil: "printDCurMil", DestTemp: "printDTemporal", ReservaAct: "printDReservaAct",
                PostOgdAlfabetico: "printDPosteriorAlfabetico",
                PostOgdFechas: "printDPosteriorFechas",
            },

            // títulos bonitos para el modal
            titlesMap: {
                Daen: "DAEN", Dem: "DEM", Depss: "DEPSS", Dim: "DIM", Magister: "MAGISTER",
                Frontera: "FRONTERA", Profesional: "PROFESIONAL", ProLibro: "PROLIBRO", EspecialidadProf: "ESPECIALIDAD PROFESIONAL",
                incorpInstituosMil: "INCORP. EGR. II.MM.", incorpPersCivil: "INCORP. PERS. CIVIL",
                reincorpPersCivil: "REINCORP. PERS. CIVIL", reincorpPersMil: "REINCORP. PERS. MILITAR",
                incorpArt114: "INCORP. ART. 114", incorpArt118: "INCORP. ART. 118",
                Lactancia: "LACTANCIA", Natalidad: "NATALIDAD", Mortalidad: "MORTALIDAD",
                Prenatal: "PRENATAL", LactanciaConPaquete: "LACTANCIA CON PAQUETE", PrenatalConPaquete: "PRENATAL CON PAQUETE",
                LetraA: 'LETRA "A" TRÁMITE JUBILACIÓN', LetraB: 'LETRA "B" DISPONIBILIDAD',
                LetraC: 'LETRA "C" COMISIÓN SUPREMO GOB.', LetraD: 'LETRA "D" DISP. TRAT. MÉD.',
                LetraEjustMil: 'LETRA "E" JUST. MILITAR', LetraEjustOrd: 'LETRA "E" JUST. ORDINARIA',
                AplicArt87: "APLICACIÓN ART. 87", AplicArt114: "APLICACIÓN ART. 114",
                cLetraB: "CONCL. LETRA B", cLetraC: "CONCL. LETRA C", cLetraD: "CONCL. LETRA D",
                cLetraEjustMil: "CONCL. LETRA E (JUST. MIL.)", cLetraEjustOrd: "CONCL. LETRA E (JUST. ORD.)",
                cBonoProLibro: "CONCL. BONO PRO LIBRO", cCursoMil: "CONCL. CURSO MILITAR", cDestinoMil: "CONCL. DESTINO TEMPORAL",
                csefectobdisponible: "SIN EFECTO LETRA B DE DISPONIBILIDAD",
                ExoneracionCargo: "BAJA POR EXONERACIÓN DEL CARGO", Fallecimiento: "BAJA POR FALLECIMIENTO",
                Jubilacion: "PASE AL SERVICIO PASIVO",
                RetiroObligatorio: "BAJA POR RETIRO OBLIGATORIO", RetiroVoluntario: "BAJA POR RETIRO VOLUNTARIO",
                BajaTemporalLicenciaMaxima: "BAJA TEMPORAL LICENCIA MÁXIMA", BajaLicenciaTemporal: "BAJA POR LICENCIA TEMPORAL",
                BPasepasivo: "PASE A LA JUBILACIÓN",

                // === NUEVOS ===
                BajaJubilacion: "PASE AL SERVICIO PASIVO",
                BajaDefArt94: "BAJA DEFINITIVA DEL EJÉRCITO – ART. 94° LOFA",
                BajaDefArt127: "BAJA DEFINITIVA – ART. 127° CÓDIGO PENAL MILITAR",
                BajaArt94y127: "BAJA – ART. 94° LOFA y ART. 127° CÓDIGO PENAL MILITAR",
                BajaResPTJM: "BAJA POR RESOLUCIÓN PTJM",
                BajaResTSJM: "BAJA POR RESOLUCIÓN TSJM",
                oga: "ASCENSOS POR O.G.A.", PostOga: "ASCENSOS POSTERIOR A O.G.A.", Postumo: "ASCENSO PÓSTUMO",
                CambioEscalafon: "CAMBIO DE ESCALAFÓN", ModificacionDatos: "MODIFICACIÓN DE DATOS",
                ogd: "CAMBIO DE DESTINO POR O.G.D.", PostOgd: "CAMBIO POSTERIOR A O.G.D.", PostOgdAlfabetico: "POST. O.G.D. (ORD. ALFABÉTICO)",
                PostOgdFechas: "POST. O.G.D. POR FECHAS",
                Radicatoria: "RADICATORIA", CursoMil: "CURSO MILITAR", DestTemp: "DESTINO TEMPORAL", ReservaAct: "RESERVA ACTIVA",
            },
        };
    },

    computed: {
        fechasValidas() {
            const d = this.variables?.FechaDesde, h = this.variables?.FechaHasta;
            return !!(d && h && d <= h);
        },
        currentModal() {
            if (!this.currentKey) return { title: "", onGenerate: null };
            return {
                title: this.titlesMap[this.currentKey] || this.currentKey,
                onGenerate: this.actionMap[this.currentKey] || null
            };
        },
        cuadroFechasValidas() {
            const d = this.cuadrosba?.FechaDesde, h = this.cuadrosba?.FechaHasta;
            return !!(d && h && d <= h);
        }
    },

    created() {
        // asegurar que todos los switches existan
        this.groups.forEach(g =>
            g.options.forEach(o => {
                if (!(o.key in this.cuadros)) this.$set(this.cuadros, o.key, false);
            })
        );

        // generar alias openPdfFrom(...) para todos los métodos del servicio que usas
        [
            // Permanentes
            "printPDaen", "printPDem", "printPDepss", "printPDim", "printPMagister",
            // Eventuales
            "printEFrontera", "printEProfesional", "printEProlibro", "printEEspecialidadprof",
            // Altas
            "printAIniimm", "printAInpc", "printAReipc", "printAReipm", "printAIncorporacion114", "printAIncorporacion118",
            // Asig. familiares
            "printAFLactancia", "printAFNatalidad", "printAFMortalidad", "printAFPrenatal", "printAFLactanciaConPaquete", "printAFPrenatalConPaquete",
            // Letras
            "printLLetraA", "printLLetraB", "printLLetraC", "printLLetraD", "printLLetraEJM", "printLLetraEJO", "printLArt87", "printLArt114",
            // Conclusiones
            "printCConclusionLetraB", "printCConclusionLetraC", "printCConclusionLetraD", "printCConclusionLetraEJM", "printCConclusionLetraEJO", "printCConclusionProLibro", "printCConclusionCursoMil", "printCConclusionDestinoTemp",
            // Bajas (incluye 89/90 reales)
            "printBExoneracion", "printBFallecido", "printBJubilacion", "printBPasepasivo", "printBBajaTLM", "printBBajaLT", "printBRetiro89", "printBRetiro90", "printBBajaArt94y127",
            "printBBajaDefArt94",
            "printBBajaDefArt127",
            "printBBajaResPTJM",
            "printBBajaResTSJM",
            // Ascensos
            "printASOGA", "printASPosteriorOGA", "printASPostumo",
            // Varios
            "printVEscalafon", "printVModificacion",
            // Destinos
            "printDOGD", "printDPosterior", "printDPosteriorFechas", "printDRadicatoria", "printDCurMil", "printDTemporal", "printDReservaAct", "printDPosteriorAlfabetico",
            // Generales
            "printPermanenteGral", "printEventualGral", "printAltasGral", "printAsignacionGral", "printLetrasGral", "printConclucionesGral", "printBajasGral", "printAscensosGral", "printVariosGral", "printDestinosGral", "printCuadroAlteracionesGral",
            // Cuadro
            "printReporteCuadro"
        ].forEach(m => { this[m] = (payload) => this.openPdfFrom(m, payload); });
    },

    methods: {
        // --- helpers
        openPdfFrom(serviceMethodName, payload = this.variables) {
            const fn = this.ss[serviceMethodName];
            if (typeof fn !== "function") {
                console.warn("[openPdfFrom] Método no encontrado:", serviceMethodName);
                this.$bvToast && this.$bvToast.toast("Acción no disponible.", { variant: "warning", solid: true });
                return;
            }
            this.isLoading = true;
            return fn.call(this.ss, payload)
                .then((result) => {
                    const urlFile = result?.data?.data;
                    if (urlFile?.url) {
                        const dir = this.rutaApp + urlFile.url;
                        window.open(dir);
                    } else {
                        throw new Error("Respuesta sin URL");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$bvToast && this.$bvToast.toast("No se pudo generar el archivo.", {
                        title: "Error", variant: "danger", autoHideDelay: 5000, solid: true
                    });
                })
                .finally(() => { this.isLoading = false; });
        },

        openModal(key) {
            this.currentKey = key;
            this.showModal = true;
        },

        runCurrentGenerate() {
            const method = this.currentModal.onGenerate;
            this.showModal = false;
            if (method) this.openPdfFrom(method);
        },

        // --- API existentes
        getConceptoSP() {
            this.ss.listConceptoSP()
                .then(res => { this.conceptosp = res.data.data; })
                .catch(err => console.log(err));
        },
        getSituacioConcepto() {
            this.ss.listSituacionConcepto()
                .then(res => { this.situacionconcepto = res.data.data; })
                .catch(err => console.log(err));
        },
        enviar() {
            this.ss.generaReporte(this.variables)
                .then(res => { console.log(res.data); })
                .catch(error => {
                    this.errorBag = error?.response?.data?.errors || {};
                    console.log(error?.response?.data);
                    this.$bvToast && this.$bvToast.toast(
                        "Problema al Guardar el Registro, favor verificar los Datos",
                        { title: "Error", variant: "danger", autoHideDelay: 5000 }
                    );
                });
        },
        exportexcel() {
            this.ss.exportexcel()
                .then(result => {
                    const href = result?.data;
                    const link = document.createElement("a");
                    link.setAttribute("download", "reporte.xlsx");
                    link.href = href;
                    link.target = "_blank";
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch(error => {
                    this.errorBag = error?.response?.data?.errors || {};
                    console.log(error?.response?.data);
                    this.$bvToast && this.$bvToast.toast(
                        "Problema al Guardar el Registro, favor verificar los Datos",
                        { title: "Error", variant: "danger", autoHideDelay: 5000 }
                    );
                });
        },

        // --- generales (compat con tu template)
        pdfpermanente() { return this.printPermanenteGral(); },
        pdfEventual() { return this.printEventualGral(); },
        pdfAltas() { return this.printAltasGral(); },
        pdfAsignacion() { return this.printAsignacionGral(); },
        pdfLetras() { return this.printLetrasGral(); },
        pdfConcluciones() { return this.printConclucionesGral(); }, // nombre original
        pdfConclusiones() { return this.pdfConcluciones(); },       // alias si el template usa “Conclusiones”
        pdfBajas() { return this.printBajasGral(); },
        pdfAscensos() { return this.printAscensosGral(); },
        pdfVarios() { return this.printVariosGral(); },
        pdfDestinos() { return this.printDestinosGral(); },
        pdfCuadroAlteraciones() { return this.printCuadroAlteracionesGral(); },

        // --- switches helper
        toggleGroup(group, value) {
            group.options.forEach(opt => { this.$set(this.cuadros, opt.key, !!value); });
        },
        countSelected(group) {
            return group.options.reduce((acc, opt) => acc + (this.cuadros[opt.key] ? 1 : 0), 0);
        },

        // --- cuadro de alteraciones (no muta los checkboxes)
        reportecuadro() {
            const codeMap = {
                Daen: 2, Dem: 3, Depss: 5, Dim: 4, Magister: 1,
                Frontera: 7, Profesional: 8, ProLibro: 6, EspecialidadProf: 63,
                incorpInstituosMil: 9, incorpPersCivil: 10, reincorpPersCivil: 12, reincorpPersMil: 11,
                incorpArt114: 51, incorpArt118: 52,
                Lactancia: 59, Natalidad: 14, Mortalidad: 15, Prenatal: 13,
                LetraA: 16, LetraB: 17, LetraC: 18, LetraD: 19,
                LetraEjustMil: 20, LetraEjustOrd: 46, AplicArt87: 54, AplicArt114: 60,
                cLetraB: 22, cLetraC: 23, cLetraD: 24, cLetraEjustMil: 25, cLetraEjustOrd: 48,
                cBonoProLibro: 26, cCursoMil: 28, cDestinoMil: 27,
                ExoneracionCargo: 30, Fallecimiento: 29, Jubilacion: 35,
                RetiroObligatorio: 31, RetiroVoluntario: 34,
                BajaTemporalLicenciaMaxima: 57, BajaLicenciaTemporal: 58,
                oga: 36, PostOga: 37, Postumo: 53,
                CambioEscalafon: 41, ModificacionDatos: 42,
                ogd: 43, PostOgd: 44, Radicatoria: 45, CursoMil: 55, DestTemp: 56, ReservaAct: 47,
                csefectobdisponible: 69,
                BajaResTSJM: 32,
                BajaResPTJM: 33,
                BajaJubilacionCivil: 64,
                BajaArt94y127: 65,
                BajaDefArt94: 66,
                BajaDefArt127: 67,
                BajaJubilacionObservada: 68
                // PostOgdAlfabetico / LactanciaConPaquete / PrenatalConPaquete: sin código → se envían boolean/0
            };

            const payload = {
                FechaDesde: this.cuadrosba?.FechaDesde || null,
                FechaHasta: this.cuadrosba?.FechaHasta || null
            };

            this.groups.forEach(g => g.options.forEach(o => {
                if (o.key in codeMap) {
                    payload[o.key] = this.cuadros[o.key] ? codeMap[o.key] : 0;
                } else {
                    payload[o.key] = this.cuadros[o.key] ? true : 0;
                }
            }));

            // guardar (por compat) y enviar
            this.cuadrosba = { ...this.cuadrosba, ...payload };
            this.printReporteCuadro(this.cuadrosba);
        },

        setReset() {
            this.variables = { FechaDesde: null, FechaHasta: null };
            this.cuadrosba = { FechaDesde: null, FechaHasta: null };
            // si también quieres apagar todos los switches:
            // Object.keys(this.cuadros).forEach(k => this.$set(this.cuadros, k, false));
        },
    },

    mounted() {
        this.getConceptoSP();
        this.getSituacioConcepto();
        const persona = JSON.parse(localStorage.getItem("persona"));
        this.auth = persona || {};
        if (!persona) this.$router.push("/Login");
    },
};
